import React from "react";
import { useNavigate } from "react-router-dom";
import Banner from "../components/Banner";

const Welcome = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  return (
    <div className="container-welcome">
      <Banner />
      <center><h1 className="title">Consorcio Industrial</h1>
      <div className="container2">
      <button onClick={handleLoginRedirect}  className="button">Iniciar Sesión</button>
      </div></center><br/><br/><br/><br/>
    </div>
  );
};

export default Welcome;